import React from 'react';
import { DivMouseHandler } from 'shared/types/commonPropTypes';

type CircleButtonProps = {
  onClick: DivMouseHandler;
  text: string;
  icon: string;
  active?: boolean;
};

export default function CircleButton(props: CircleButtonProps) {
  return (
    <div onClick={props.onClick}>
      <div
        className={
          'circle-button group w-[70px] h-[70px] rounded-full text-center mx-auto cursor-pointer bg-white hover:bg-ev-baby-blue-2 active:bg-ev-navy-blue-2' +
          (props.active ? 'active' : '')
        }
      >
        <span className={`relative top-[19px] text-3xl fad fa-${props.icon}`} />
      </div>
      <div className="font-medium underline py-4 text-center cursor-pointer group-hover:text-ev-baby-blue-2 group-active:text-ev-navy-blue-2 group-active:font-bold group-active:no-underline">
        {props.text}
      </div>
    </div>
  );
}
